import { loadStripe } from "@stripe/stripe-js"
import { getEnv } from "@/utils"

export default loadStripe(getEnv("STRIPE_PUBLISHABLE"))
